/**
 * Route for `meta-facebook-ads-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { MetaFacebookAdsIntegrationPage } from "../features/meta-facebook-ads-integration/MetaFacebookAdsIntegrationPage";

export const metaFacebookAdsIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/meta-facebook-ads-integration",
	component: MetaFacebookAdsIntegrationPage,
});

export default metaFacebookAdsIntegrationRoute;
